
export default class BankAccountDTO {

    constructor(jsonResponse) {
        this.accountStatus = jsonResponse["accountStatus"];
        this.hasActiveBankCard = jsonResponse["hasActiveBankCard"];
        this.canIssueBankCard = jsonResponse["canIssueBankCard"];
        this.profileId = jsonResponse["profileId"];
    }
}
